export default __webpack_public_path__ + "static/media/custom-arrow.a47442f4.svg";